import { render } from "./LeadInfoBox.vue?vue&type=template&id=678bb0dd&scoped=true"
import script from "./LeadInfoBox.vue?vue&type=script&lang=js"
export * from "./LeadInfoBox.vue?vue&type=script&lang=js"

import "./LeadInfoBox.vue?vue&type=style&index=0&id=678bb0dd&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-678bb0dd"

export default script